"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.array.filter");

require("core-js/modules/es.array.for-each");

require("core-js/modules/es.object.assign");

require("core-js/modules/es.object.define-properties");

require("core-js/modules/es.object.define-property");

require("core-js/modules/es.object.get-own-property-descriptor");

require("core-js/modules/es.object.get-own-property-descriptors");

require("core-js/modules/es.object.keys");

require("core-js/modules/web.dom-collections.for-each");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = InputField;

var _TextField2 = _interopRequireDefault(require("@material-ui/core/TextField"));

var _CircularProgress2 = _interopRequireDefault(require("@material-ui/core/CircularProgress"));

var _InputAdornment2 = _interopRequireDefault(require("@material-ui/core/InputAdornment"));

var _react = _interopRequireDefault(require("react"));

var _makeStyles = _interopRequireDefault(require("@material-ui/core/styles/makeStyles"));

var _Box = _interopRequireDefault(require("./Box"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function InputField(_ref) {
  var autoFocus = _ref.autoFocus,
      errorStyles = _ref.errorStyles,
      errorText = _ref.errorText,
      helperText = _ref.helperText,
      Icon = _ref.icon,
      _ref$iconColor = _ref.iconColor,
      iconColor = _ref$iconColor === void 0 ? "disabled" : _ref$iconColor,
      inputFieldStyles = _ref.inputFieldStyles,
      label = _ref.label,
      loading = _ref.loading,
      margin = _ref.margin,
      maxLength = _ref.maxLength,
      multiline = _ref.multiline,
      onChange = _ref.onChange,
      onClick = _ref.onClick,
      onKeyDown = _ref.onKeyDown,
      params = _ref.params,
      placeholder = _ref.placeholder,
      textFieldStyles = _ref.textFieldStyles,
      value = _ref.value,
      variant = _ref.variant,
      width = _ref.width;
  var useStyles = (0, _makeStyles["default"])({
    textField: _objectSpread(_objectSpread({}, textFieldStyles), {}, {
      flexGrow: 1,
      "& input": _objectSpread({
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
      }, inputFieldStyles)
    }),
    icon: {
      marginLeft: 10
    }
  });
  var classes = useStyles();
  return /*#__PURE__*/_react["default"].createElement(_Box["default"], {
    display: "flex",
    flex: 1,
    maxWidth: width
  }, /*#__PURE__*/_react["default"].createElement(_TextField2["default"], _extends({}, params, margin && {
    margin: margin
  }, multiline && {
    rows: 4
  }, {
    className: errorStyles || classes.textField,
    error: !!errorText,
    helperText: errorText || helperText,
    multiline: multiline,
    placeholder: placeholder,
    onClick: onClick,
    onChange: onChange,
    onKeyDown: onKeyDown,
    InputProps: _objectSpread(_objectSpread(_objectSpread(_objectSpread({
      autoFocus: autoFocus,
      disableUnderline: true
    }, maxLength && {
      inputProps: {
        maxLength: maxLength
      }
    }), params === null || params === void 0 ? void 0 : params.InputProps), Icon && {
      startAdornment: /*#__PURE__*/_react["default"].createElement(_InputAdornment2["default"], {
        position: "start"
      }, /*#__PURE__*/_react["default"].createElement(Icon, {
        className: classes.icon,
        color: iconColor
      }))
    }), Icon && loading && {
      endAdornment: /*#__PURE__*/_react["default"].createElement(_CircularProgress2["default"], {
        color: "inherit",
        size: 20
      })
    }),
    label: label,
    value: value,
    variant: variant
  })));
}